(ns app.components.checkbox.styles
  (:require-macros)
  (:require
   [spade.core   :refer [defglobal defclass]]))

(defclass parent-checkbox-style
  [] {}
  [:MuiCheckbox {:colorPrimary {:color "blue"}}])


(defclass select-all-button
  [] {:width "165px"}
  [:.rc-checkbox-wrapper {:background-color "#2B2A35"
                          :flex "0 0 auto"
                          :cursor "default"
                          :color "#EBEBFF"
                          :align-items "center !important"
                          :vertical-align "center"
                          :padding "9px 24px"
                          :height "26px"
                          :font-weight "600"
                          :font-size "16px"}])



(defclass checkbox-style
  [] {:width "15px"
      :height "15px"
      :border-radius "5px"
      :border "2px solid #555"}
  [:&:hover
   {:accent-color "purple"}]
  [:&:focus
   {}]
  [:&:active
   {}]
  [:&:checked
   {:accent-color :theme/*purpleActive*
    :width "15px"
    :height "15px"
    :border-radius "5px"
    :border "2px solid #555"}])
